import normalizeEntity from 'normalized-redux/entity-normalizer';

const normalizedTagConnections = normalizeEntity({ entity: 'tagConnection' });

export default normalizedTagConnections;
